import { phoneFormat } from './phoneHelper';
// import Cookies from 'js-cookie';
// import { jwtDecode } from 'jwt-decode';
//
// import { domain } from './apiHelper';

// export const siteUrl = () => getSettings().url;

export const pad = (padString, str) => {
  if (typeof str === 'undefined') {
    return padString;
  }
  return (padString + str).slice(-padString.length);
};

export const removeSpaces = (string) => {
  let newString = string;
  newString = newString.replace(/ /g, '');
  return newString;
};

// export const yesNoFormat = boolean => {
//   if (boolean) {
//     return 'Yes';
//   }
//   return 'No';
// };

// export const currentAccountId = () => {
//   const token = Cookies.get('token');
//   return jwtDecode(token).sub;
// };

export const getDefaultCountryCode = (settings) =>
  settings.data.defaultCountryCode;

export const getCurrency = (settings) => settings.data.currency;

export const getCompanyName = (settings) => settings.data.companyName;

export const getLogo = (settings) => settings.data.logo;

export const getUrl = (settings) => settings.data.url;

export const getContinueShopping = (settings) => settings.data.continueShopping;

export const getClubList = (settings) => settings.data.clubList;

export const getOperatingCountryCodes = (settings) =>
  settings.data.operatingCountryCodes;

export const getOperatingStateCodes = (settings) =>
  settings.data.operatingStateCodes;

export const getMessage = (title, settings) => {
  let message = settings.data.websiteMessages[title];
  message = replaceVariables(message, settings.data);
  return message;
};

const replaceVariables = (message, settings) => {
  let newMessage = message;
  newMessage = newMessage.replace(/{{companyName}}/g, settings.companyName);
  newMessage = newMessage.replace(
    /{{primaryPhone}}/g,
    phoneFormat(settings.primaryPhone, settings.defaultCountryCode)
  );
  newMessage = newMessage.replace(/{{primaryEmail}}/g, settings.primaryEmail);
  newMessage = newMessage.replace(/{{url}}/g, settings.url);
  newMessage = newMessage.replace(
    /{{continueShopping}}/g,
    settings.continueShopping
  );
  return newMessage;
};

export const getMinimumAge = (settings) => settings.data.minimumAge;

export const imageFile = (image, newSize) => {
  const allowedSizes = ['small', 'medium', 'large', 'x-large'];
  if (!allowedSizes.includes(newSize)) {
    throw new Error('Invalid Image Size');
  }
  return image.replace('original', newSize);
};

export const cartHasPrime = (cart) => {
  let hasPrime = false;
  if (cart.primeMembership) {
    hasPrime = true;
  }
  cart.items.forEach((item) => {
    if (item.type === 'Prime') {
      hasPrime = true;
    }
  });
  return hasPrime;
};

export const cartHasGiftCards = (cart) => {
  let hasGiftCards = false;
  const giftCard = cart.tenders.find(
    (tender) =>
      tender.tenderType === 'Gift Card' &&
      tender.amountTendered > 0 &&
      tender.chargeStatus !== 'Failed'
  );
  if (giftCard) {
    hasGiftCards = true;
  }
  return hasGiftCards;
};

export const getAmountTenderedByGiftCard = (cart) => {
  const amount = cart.tenders.reduce((total, tender) => {
    if (tender.chargeStatus !== 'Failed' && tender.tenderType === 'Gift Card') {
      return total + tender.amountTendered;
    }
    return total;
  }, 0);
  return amount;
};

export const getCartTitle = (settings) => {
  if (settings?.data?.defaultCountryCode === 'GB') {
    return 'Basket';
  }
  return 'Cart';
};
